module.exports = __webpack_public_path__ + "img/generation.849337f9.png";